/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NursingInterventionsViewerAliases {
  EXECUTE_TIME_BUTTON = 'execute-time-button',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  NURSING_INTERVENTIONS_CONTEXTUAL_BAR = 'nursing-interventions-contextual-bar',
  NURSING_INTERVENTIONS_DECK = 'nursing-interventions-deck',
  NURSING_INTERVENTIONS_DETAILS_CARD = 'nursing-interventions-details-card',
  NURSING_INTERVENTIONS_FOOTER_PANEL = 'nursing-interventions-footer-panel',
  NURSING_INTERVENTIONS_VIEWER_LAYOUT = 'nursing-interventions-viewer-layout',
  PANEL_HEADER = 'panel-header',
  PANEL_NURSING_INTERVENTIONS_CONTENT = 'panel-nursing-interventions-content',
  RESCHEDULE_NURSING_INTERVENTIONS_ACTION = 'reschedule-nursing-interventions-action',
  REVERSE_NURSING_INTERVENTATIONS_ACTION = 'reverse-nursing-interventations-action',
  SUSPEND_NURSING_INTERVENTIONS_ACTION = ' suspend-nursing-interventions-action',
}
export { NursingInterventionsViewerAliases };
